module.exports = __webpack_public_path__ + "static/media/bg-6.f6bb3766.png";